
(function(){
    $('.modal-trigger.restore-cart').each(function () {
        $(this).click(function () {
            $(this).closest('form').submit();
            return false;
        });
    });
})();
